export default "__VITE_ASSET__Cg79IpAg__"